module.exports = __webpack_public_path__ + "img/流程定义.25fbc621.svg";